import currentDevice from 'current-device';

const isMobile = currentDevice.mobile();
export default isMobile;
